import React from 'react';
import { Modal } from 'antd';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';
import './index.scss';
import { useSelector } from 'react-redux';

export const LoginModal = ({ visible, onClose }) => {
  const { currentKey } = useSelector((state) => state.loginModalReducer);
  return (
    <Modal
      className="login-modal"
      visible={visible}
      // onOk={onOk}
      onCancel={onClose}
      // closable={false}
      footer={null}
      width={760}
    >
      <div className="login-form-warpper">
        <div className="aside">
          <span className="logo1" />
        </div>
        {currentKey === 1 && <LoginForm onClose={onClose} />}
        {currentKey === 2 && <RegisterForm onClose={onClose} />}
      </div>
    </Modal>
  );
};
